import { render } from "./CollectionStoreListView.vue?vue&type=template&id=242e9bdb&scoped=true"
import script from "./CollectionStoreListView.vue?vue&type=script&lang=js"
export * from "./CollectionStoreListView.vue?vue&type=script&lang=js"

import "./CollectionStoreListView.vue?vue&type=style&index=0&id=242e9bdb&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242e9bdb"]])

export default __exports__